import InternalNoteTag from "./internalNoteTag.component";

export default InternalNoteTag;
